module.exports = __webpack_public_path__ + "img/生产-手机标签.e8acc3cb.jpg";